/**
 * CV Analyzer translations
 * CV analysis page UI text
 */

import { LANGUAGES } from '../config';

export const cvAnalyzerTranslations = {
  [LANGUAGES.EN]: {
    title: 'CV Analyzer',
    uploadStep: 'Upload CV',
    reviewStep: 'Review Analysis',
    uploadCV: 'Upload CV',
    reviewAnalysis: 'Review Analysis',
    uploadText: 'Upload CV files or drag and drop them here',
    pasteText: 'Or paste CV text directly',
    competencyResults: 'Competency Analysis Results',
    competenciesAnalysisResults: 'Competencies Analysis Results',
    addCompetency: 'Add Competency',
    editCompetency: 'Edit Competency',
    competency: 'Competency',
    category: 'Category',
    proficiency: 'Proficiency',
    categoryLoadError: 'Failed to load CV categories from the backend.',
    evidence: 'Evidence',
    technical: 'Competences techniques',
    softSkills: 'Competences comportementales',
    leadership: 'Leadership',
    domainKnowledge: 'Connaissance du domaine',
    tools: 'Outils et plateformes',
    methodologies: 'Methodologies et pratiques de travail',
    certifications: 'Certifications',
    other: 'Other',
    theoretical: 'Theorique',
    beginner: 'Debutant',
    intermediate: 'Intermediaire',
    advanced: 'Avance',
    expert: 'Expert',
    evidenceContext: 'Evidence / Context',
    noCompetencies: 'No competencies found. Add some using the button above.',
    newStatus: 'New',
    modifiedStatus: 'Modified',
    savedSuccessfully: 'CV analysis saved successfully!',
    analysisFailed: 'CV analysis failed',
    processing: 'Processing your CV...',
    dragAndDrop: 'Drag and drop CV file here, or click to select file'
  },
  [LANGUAGES.FR]: {
    title: 'Analyseur de CV',
    uploadStep: 'Telecharger CV',
    reviewStep: 'Reviser l\'analyse',
    uploadCV: 'Telecharger CV',
    reviewAnalysis: 'Reviser l\'analyse',
    uploadText: 'Telechargez des fichiers CV ou glissez-les ici',
    pasteText: 'Ou collez le texte du CV directement',
    competencyResults: 'Resultats d\'analyse des competences',
    competenciesAnalysisResults: 'Resultats d\'analyse des competences',
    addCompetency: 'Ajouter une competence',
    editCompetency: 'Modifier la competence',
    competency: 'Competence',
    category: 'Categorie',
    proficiency: 'Niveau',
    categoryLoadError: 'Echec du chargement des categories CV depuis le backend.',
    evidence: 'Evidence',
    technical: 'Competences techniques',
    softSkills: 'Competences comportementales',
    leadership: 'Leadership',
    domainKnowledge: 'Connaissance du domaine',
    tools: 'Outils et plateformes',
    methodologies: 'Methodologies et pratiques de travail',
    certifications: 'Certifications',
    other: 'Autre',
    theoretical: 'Theorique',
    beginner: 'Debutant',
    intermediate: 'Intermediaire',
    advanced: 'Avance',
    expert: 'Expert',
    evidenceContext: 'Evidence / Contexte',
    noCompetencies: 'Aucune competence trouvee. Ajoutez-en a l\'aide du bouton ci-dessus.',
    newStatus: 'Nouveau',
    modifiedStatus: 'Modifie',
    savedSuccessfully: 'Analyse de CV enregistree avec succes!',
    analysisFailed: 'L\'analyse du CV a echoue',
    processing: 'Traitement de votre CV...',
    dragAndDrop: 'Glissez et deposez le fichier CV ici, ou cliquez pour selectionner un fichier'
  }
};
